$(document).ready(function(){  
  // Logolist Slider
  $('.logo_list_slide').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
             adaptiveHeight: true,
            },
          },
         {
            breakpoint: 820,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              adaptiveHeight: true,
            },
          },
         {
            breakpoint: 480,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          }
    ]
  });


  // Blogs Slider
  $('.custom-blog .blog__posts').slick({   
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 16.5L1.25 9L8.75 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5L8.75 9L1.25 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 2,
           adaptiveHeight: true,
          },
        },
       {
          breakpoint: 820,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            adaptiveHeight: true,
          },
        },
       {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }
      ]
  });  


  // Collection List Slider
$('.custom-collection-list-wrapper .custom-collection-list').slick({  
  infinite: false,
  arrows: true,
  prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 16.5L1.25 9L8.75 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5L8.75 9L1.25 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  slidesToShow: 6,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

  

 
  $('.col_pg_slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 1000,
      arrows:true,
      prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 16.5L1.25 9L8.75 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5L8.75 9L1.25 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
      dots: true,
      dotsClass: 'custom_paging',  
      customPaging: function (slider, i) {
      // console.log(slider);
      return  (i + 1) + '/' + slider.slideCount;
     }      
  });

  
// product-page tab
  $(".tab_sub_txt").click(function(){
    $(this).closest('.tab_qt_tb').find(".tab_qt_ans").slideToggle();
    $(this).closest('.tab_qt_tb').find("i").toggleClass("fa fa-plus fa fa-minus");

    var id=$(this).closest('.tab_qt_tb').attr("id"); 
    $(".tab_qt_tb").not("#"+id).find(".tab_qt_ans").slideUp();
    $(".tab_qt_tb").not("#"+id).find('i').attr('class',"fa fa-plus");
  });


// Selected Product Variant name on Product Title
$('.product_radio label').click(function(){
  var v_text =  $(this).text();
    $( ".product__title span" ).remove();
    $( ".product__title h1" ).append("<span> - " + v_text + "</span>");
});

  var opt = $('.product_radio input[type=radio]:checked+label ').text();
    // alert(opt);
    if (opt) {
      $( ".product__title span" ).remove();
      $( ".product__title h1" ).append("<span> - " + opt + "</span>");
  };

  
  // Slider on Product Variant Swatches
  $('.product_radio .product_swatches_color').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    infinite: false,
    arrows: true,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 16.5L1.25 9L8.75 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5L8.75 9L1.25 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 820,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
  });



$('.product-p1').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  fade: true,
  prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 16.5L1.25 9L8.75 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5L8.75 9L1.25 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
  asNavFor: '.product-p2'
});
  
$('.product-p2').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-p1',
    dots: false,
    centerMode: false,
    focusOnSelect: true,
    arrows: false,
    prevArrow:'<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.75 16.5L1.25 9L8.75 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    nextArrow:'<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.25 16.5L8.75 9L1.25 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>',
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true
        }
      }
    ]
});


  // select variant change img
  
  $(".product_swatches_color .product_swatch_color__main").click(function(){
    $('.invt_icon').hide();
  var image_merge = $(this).find('img').attr('data-id');
      // alert(image_merge);
      $('.cust-product-img2 img').each(function(){
        var thumb_img_id =  $(this).attr('data-img');
        // console.log(thumb_img_id);
        if(image_merge == thumb_img_id){
          $(this).trigger('click');
        }
      });
  });

  var slct = $('.product_radio input[type=radio]:checked+label img ').attr('data-id');
  // alert(slct);
    if (slct) {
        $('.cust-product-img2 img').each(function(){
        var slct_img =  $(this).attr('data-img');
        // console.log(thumb_img_id);
        if(slct == slct_img){
          $(this).trigger('click');
        }
      });
  };
  /*
 var array = [];
  $(".button__radio").click(function(){
    var image_merge = $(this).toggleClass('selected');
    $(this).parent('.additional_product_list').toggleClass('selected_pd');
   var im_m
  $(im_m).val('');
  //  alert(im_m);
      if( $('.check_input').is(':checked') ) {
       array = array
         $('.selected_pd').each(function(){
         var im_m = $(this).attr('data-id');
          array.push(im_m)
          console.log(im_m);
       });
     //   alert(array);
      }
array =array
function addAllItems(array){
	Shopify.queue = [];
	  var quantity =1 ;
	  var newArray = array.split(',');
	  for (var i = 0; i < newArray.length; i++) {
	    product = newArray[i]
	    Shopify.queue.push({
	      variantId: product,
	    });
          }
	  Shopify.moveAlong = function() {
	  // If we still have requests in the queue, let's process the next one.
	  if (Shopify.queue.length) {
	    var request = Shopify.queue.shift();
	    var data = 'id='+ request.variantId + '&quantity=1'
	    $.ajax({
	      type: 'POST',
              url: '/cart/add.js',
	      dataType: 'json',
	      data: data,
	      success: function(res){
	        Shopify.moveAlong();
		  quantity += 1;
	     },
             error: function(){
	     // if it's not last one Move Along else update the cart number with the current quantity
		  if (Shopify.queue.length){
		    Shopify.moveAlong()
		  } else {
	//	    $('#cart-number').replaceWith('<a href="/cart" id="cart-number">View cart (" + quantity + ")</a>")
		  }
	      }
           });
        }
	 // If the queue is empty, we add 1 to cart
	else {
	  quantity += 1;
	  addToCartOk(quantity);
	 }
       };
    Shopify.moveAlong();
  };


addAllItems(array);

    

  });

*/
  
  // add-one product

 $("input:checkbox:checked").attr("checked", "");

  $(".check_input").click(function() {
     $(this).closest('.additional_product_list').find('.button__radio ').toggleClass('selected');
     var array = [];
     array = array;
         $('.check_input:checked').each(function(){
         var add_pr = $(this).val();
          array.push(add_pr);
         });
    console.log(array);
    $('.product-form__submit').attr('onclick' ,"addAllItems("+"'"+array+"'"+")");
  });


window.addEventListener( "pageshow", function ( event ) {
  var historyTraversal = event.persisted || ( typeof window.performance != "undefined" && window.performance.navigation.type === 2 );
  if ( historyTraversal ) {
    // Handle page restore.
    //alert('refresh');
    window.location.reload();
  }
});
});

$('.see-more_btn_product').click(function(){
  $('ul.additional_product li:nth-child(3)').slideToggle();
  $('ul.additional_product li:nth-child(4)').slideToggle();
  // $('ul.additional_product li:last-child').toggleClass('hide_add-product');
});